import { useState } from 'react';

import { useLazyQuery } from '@apollo/client';
import { AutoCompleteCompleteEvent } from 'primereact/autocomplete';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useSearchQuery<T>(query: any, resultKey: string) {
  const [filteredResults, setFilteredResults] = useState<T[]>();
  const [searchQuery] = useLazyQuery(query);

  const search = (e: AutoCompleteCompleteEvent) => {
    const { query } = e;
    searchQuery({
      variables: { query },
    }).then((res) => {
      setFilteredResults(res.data?.[resultKey]?.items as T[]);
    });
  };

  return { filteredResults, search, setFilteredResults };
}
